import { BaseReactComponent } from '@eastsideco/salvo-ts';

export abstract class ThemeReactComponent extends BaseReactComponent {
    abstract render(): JSX.Element;
}

